import axios from "axios";
import React, { useEffect, useState } from "react";
import Collapsible from "react-collapsible";
import { Config } from "../../../../../Config";
import CursorPopup from "../../ShareElements/CursorPopup/CursorPopUp";
import { translateText } from "../../../../../Helper_functions";

const ChatItem = (props) => {
  const [HasUnreadMessages, setHasUnreadMessages] = useState(false);

  useEffect(() => {
    handleUnreadState();
  }, [props.Conversation]);

  const handleUnreadState = () => {
    let ChatCounters = [];
    let Read = [];
    props.ChatItems.map((Item) => {
      ChatCounters.push(Item.counter);
      if (Item.counter === 0) {
        Read.push(Item.counter);
      }
      if (Read.length === ChatCounters.length) {
        setHasUnreadMessages(false);
      } else if (ChatCounters.length > Read) {
        setHasUnreadMessages(true);
      }
    });
  };

  const addOpenState = () => {
    document
      .getElementById(props.Id + "-chevron")
      .classList.add("rotated-icon");
  };
  const removeOpenState = () => {
    document
      .getElementById(props.Id + "-chevron")
      .classList.remove("rotated-icon");
  };
  const displayTitle = (ItemTitle) => {
    if (ItemTitle.length < 16) {
      return <React.Fragment>{ItemTitle}</React.Fragment>;
    } else {
      let Shortened = ItemTitle.slice(0, 12) + " ...";
      return (
        <React.Fragment>
          <CursorPopup ShortText={Shortened} FullText={ItemTitle} />
        </React.Fragment>
      );
    }
  };
  const displayLocation = (ItemLocation) => {
    if (ItemLocation) {
      if (ItemLocation.length < 13) {
        return ItemLocation;
      } else {
        let Shortened = ItemLocation.slice(0, 10) + " ...";
        return (
          <React.Fragment>
            <CursorPopup ShortText={Shortened} FullText={ItemLocation} />
          </React.Fragment>
        );
      }
    } else {
      return translateText("not_available", props.LangData);
    }
  };
  const togglePin = (Id) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ICPServiceURL +
        "/api/" +
        props.JPAType +
        "/chat/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        recipientId: props.Conversation.details[0].recipientId,
        jpaId: props.JPAId,
        source: props.SelectedSource,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        toggleReselectChat();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  // to re-select the conversation after pin/unpin only if it was selected before
  const toggleReselectChat = () => {
    let ChatIds = [];
    let PreSelectedChatId = null; // the chat item that has been already selected
    let PreSelectedChatIndex = 0;
    props.ChatItems.map((Chat, i) => {
      ChatIds.push(Chat.chatId + "-chat-" + i);
    });
    ChatIds.map((Id, i) => {
      if (document.getElementById(Id).classList.length > 1) {
        PreSelectedChatId = Id;
        PreSelectedChatIndex = i;
      }
    });
    props.FetchChatlist(
      true,
      PreSelectedChatId,
      PreSelectedChatIndex,
      props.JPAId
    );
  };
  const displayPosTitle = (PosTitle) => {
    if (PosTitle.length < 19) {
      return PosTitle;
    } else {
      let Shortened = PosTitle.slice(0, 16) + " ...";
      return (
        <React.Fragment>
          <CursorPopup ShortText={Shortened} FullText={PosTitle} />
        </React.Fragment>
      );
    }
  };
  const displayLastMessageTime = (Time) => {
    return new Date(Time).getHours() + ":" + new Date(Time).getMinutes();
  };
  const toggleSelectChat = (i) => {
    props.SelectChat(i);
  };
  return (
    <div className="chat-item">
      {props.IsPinned ? (
        <span
          className="toggle-pin pinned"
          id={props.Id + "-pin"}
          onClick={() => togglePin(props.Id + "-pin")}
        ></span>
      ) : (
        <span
          className="toggle-pin"
          id={props.Id + "-pin"}
          onClick={() => togglePin(props.Id + "-pin")}
        ></span>
      )}
      <Collapsible
        onOpening={() => addOpenState()}
        onClosing={() => removeOpenState()}
        transitionTime={200}
        trigger={
          <section className="chat-trigger" id={props.Id + "-trigger"}>
            <i id={props.Id + "-chevron"} className="feather-chevron-right"></i>
            <p
              className={
                props.Conversation.jpaDeleted
                  ? "chat-jpa-name crossed-out"
                  : "chat-jpa-name"
              }
            >
              {displayTitle(props.Conversation.title)}
              {HasUnreadMessages ? (
                <span className="unread-circle"></span>
              ) : null}
            </p>
            {props.Conversation.jpaDeleted ? (
              <i className="feather-lock"></i>
            ) : null}
            <span className="jpa-location-info">
              <i className="feather-map-pin"></i>
              <p>{displayLocation(props.Conversation.workCity)}</p>
            </span>
          </section>
        }
      >
        <div className="chat-item-rows">
          {props.ChatItems.map((Item, i) => (
            <section
              key={i}
              className="chat-item-row"
              id={Item.chatId + "-chat-" + i}
              onClick={() => toggleSelectChat(i)}
            >
              {Item.imageThumbnailUrl === null ? (
                <span
                  className="avatar-holder"
                  style={{
                    backgroundColor: Item.defaultBackgroundColorCode,
                    color: Item.defaultTextColorCode,
                  }}
                >
                  {Item.firstName.slice(0, 1).toUpperCase() +
                    Item.lastName.slice(0, 1).toUpperCase()}
                </span>
              ) : (
                <img
                  className="profile-image"
                  alt=""
                  src={Item.imageThumbnailUrl}
                />
              )}
              <span className="chat-row-info">
                <h1>{Item.firstName + " " + Item.lastName}</h1>
                {Item.currentPositionTitle ? (
                  <p>{displayPosTitle(Item.currentPositionTitle)}</p>
                ) : (
                  ""
                )}
              </span>
              <span className="chat-row-small-info">
                <p className="time-info">
                  {displayLastMessageTime(Item.updatedTime)}
                </p>
                {Item.counter > 0 ? (
                  <React.Fragment>
                    {Item.counter > 99 ? (
                      <p className="unread-count tripple-digit">+99</p>
                    ) : (
                      <span
                        className={
                          Item.counter > 9
                            ? "unread-count double-digit"
                            : "unread-count"
                        }
                        id={"message-counter-" + i}
                      >
                        {Item.counter}
                      </span>
                    )}
                  </React.Fragment>
                ) : (
                  <p></p>
                )}
              </span>
            </section>
          ))}
        </div>
      </Collapsible>
    </div>
  );
};

export default ChatItem;
